// extracted by mini-css-extract-plugin
export var IframeWrapper = "iframe-wrapper-module--IframeWrapper--4782e";